'use client';

import React, { useEffect, useRef } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import TrackRecordSection from './components/TrackRecordSection';
import TerritorySection from './components/TerritorySection';
import PartnershipSection from './components/PartnershipSection';

export default function HomePage() {
  const cursorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Hero reveal on mount
    const heroEls = document.querySelectorAll('header .reveal-hidden');
    const isMobile = window.innerWidth < 640;
    heroEls.forEach((el, i) => {
      setTimeout(() => {
        el.classList.remove('reveal-hidden');
        el.classList.add('reveal-visible');
      }, (isMobile ? 200 : 300) + i * (isMobile ? 80 : 160));
    });

    // Custom cursor
    const cursor = cursorRef.current;
    if (!cursor) return;

    const moveCursor = (e: MouseEvent) => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
    };

    const expandCursor = () => cursor.classList.add('expanded');
    const shrinkCursor = () => cursor.classList.remove('expanded');

    window.addEventListener('mousemove', moveCursor);

    const interactives = document.querySelectorAll('a, button, [role="button"]');
    interactives.forEach((el) => {
      el.addEventListener('mouseenter', expandCursor);
      el.addEventListener('mouseleave', shrinkCursor);
    });

    return () => {
      window.removeEventListener('mousemove', moveCursor);
      interactives.forEach((el) => {
        el.removeEventListener('mouseenter', expandCursor);
        el.removeEventListener('mouseleave', shrinkCursor);
      });
    };
  }, []);

  return (
    <div className="grain-overlay min-h-screen bg-ink text-parchment">
      {/* Custom cursor — desktop only */}
      <div ref={cursorRef} className="custom-cursor" aria-hidden="true" />

      <Header />

      <main>
        <HeroSection />
        <PhilosophySection />
        <TrackRecordSection />
        <TerritorySection />
        <PartnershipSection />
      </main>

      <Footer />
    </div>
  );
}